import { useEffect } from 'react';

export const APP_LAYOUT_MOBILE_ROUTE_LOADING_EVENT =
  'app-layout:mobile-route-loading';

interface MobileRouteLoadingDetail {
  loading?: boolean;
}

const dispatchMobileRouteLoading = (loading: boolean) => {
  if (typeof window === 'undefined') return;

  window.dispatchEvent(
    new CustomEvent<MobileRouteLoadingDetail>(
      APP_LAYOUT_MOBILE_ROUTE_LOADING_EVENT,
      {
        detail: { loading },
      },
    ),
  );
};

export const useMobileRouteLoading = (loading: boolean, enabled = true) => {
  useEffect(() => {
    if (!enabled) {
      dispatchMobileRouteLoading(false);
      return;
    }

    dispatchMobileRouteLoading(loading);

    return () => {
      dispatchMobileRouteLoading(false);
    };
  }, [enabled, loading]);
};
